__turbopack_context__.v({
  "actions": "CreateProductOrderModal-module-scss-module__vaEGUq__actions",
  "card": "CreateProductOrderModal-module-scss-module__vaEGUq__card",
  "close": "CreateProductOrderModal-module-scss-module__vaEGUq__close",
  "form": "CreateProductOrderModal-module-scss-module__vaEGUq__form",
  "image-wrapper": "CreateProductOrderModal-module-scss-module__vaEGUq__image-wrapper",
  "is-hidden": "CreateProductOrderModal-module-scss-module__vaEGUq__is-hidden",
  "is-recalculating": "CreateProductOrderModal-module-scss-module__vaEGUq__is-recalculating",
  "is-spaced": "CreateProductOrderModal-module-scss-module__vaEGUq__is-spaced",
  "modal-header": "CreateProductOrderModal-module-scss-module__vaEGUq__modal-header",
  "nowrap": "CreateProductOrderModal-module-scss-module__vaEGUq__nowrap",
  "per-unit": "CreateProductOrderModal-module-scss-module__vaEGUq__per-unit",
  "product-title": "CreateProductOrderModal-module-scss-module__vaEGUq__product-title",
  "right-column": "CreateProductOrderModal-module-scss-module__vaEGUq__right-column",
  "success-content": "CreateProductOrderModal-module-scss-module__vaEGUq__success-content",
  "total": "CreateProductOrderModal-module-scss-module__vaEGUq__total",
});
